import { css } from '@emotion/react'
import { observer } from 'mobx-react'
import { generatePath, useNavigate } from 'react-router-dom'

import { routeName } from '~/@common/constants'
import { typo } from '~/@common/styles'

import type { LectureGroup, MiddleChapterLecture } from '../@service/Lecture.service'

type Props = {
  lectureGroups: LectureGroup[]
}

const MobileLectureGroupList = ({ lectureGroups }: Props) => {
  const navigate = useNavigate()

  const handleClickLecture = (lectureId: MiddleChapterLecture['id']) => {
    navigate(
      generatePath(routeName.student.lectureDetail, {
        lectureId: String(lectureId),
      }),
    )
  }

  return (
    <div css={S.container}>
      {lectureGroups.map((group) => (
        <div css={S.group} key={group.leadingCurriculum.id}>
          <div css={S.groupHeader}>{group.leadingCurriculum.name}</div>
          {group.middleChapterLectures.map((lecture) => (
            <button
              key={lecture.id}
              type="button"
              css={S.lectureItem}
              onClick={() => handleClickLecture(lecture.id)}
            >
              {lecture.title}
            </button>
          ))}
        </div>
      ))}
    </div>
  )
}

export default observer(MobileLectureGroupList)

const S = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    overflow-y: auto;
  `,
  group: css`
    display: flex;
    flex-direction: column;
    border-radius: var(--Radius-300);
    overflow: hidden;
    flex-shrink: 0;
  `,
  groupHeader: css`
    display: flex;
    align-items: center;
    padding: 20px 16px;
    background: white;
    ${typo.body02};
    font-weight: 600;
    color: var(--Colors-Gray-900);
    border-bottom: 1px solid var(--Colors-Gray-300);
  `,
  lectureItem: css`
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: white;
    ${typo.body02};
    color: var(--Colors-Gray-900);
    cursor: pointer;
  `,
}
